import Skeleton from "react-loading-skeleton";

export const HeaderSkeleton = () => (
    <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between items-start xl:items-center gap-[15px] lg:gap-[0px]">
        <div className="w-full xl:w-1/2">
            <Skeleton height={40} className="mb-2" />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
    </div>
);


export const TableSkeleton = () => (
    <div className="flex border-1 shadow mt-4 p-0 border rounded-md w-[100%] h-[100%] overflow-x-auto overflow-y-auto">
        <table className="border-[#dcdbdb] border rounded-lg w-full overflow-hidden table-auto table-section">
            <thead className="top-0 sticky border-gray-300 bg-white shadow-md">
                <tr>
                    {[...Array(2)].map((_, index) => (
                        <>
                            <th key={index} className="border-[#dbdbdb] p-3 border-r">
                                <Skeleton width={index === 0 ? 2 : 100} height={index === 0 ? 2 : 20} />
                            </th>
                            <th key={index} className="border-[#dbdbdb] p-3 border-r">
                                <Skeleton width={index === 0 ? 2 : 100} height={index === 0 ? 2 : 20} />
                            </th>
                        </>

                    ))}
                </tr>
            </thead>
            <tbody>
                {[...Array(5)].map((_, index) => (
                    <TableRowSkeleton key={index} />
                ))}
            </tbody>
        </table>
    </div>
);


export const PaginationSkeleton = () => (
    <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[14px] xl:pr-0 pb-[0] xl:pl-0 w-[100%]">
        <div>
            <Skeleton width={150} />
        </div>
        <div className="flex gap-2">
            <Skeleton width={80} height={30} />
            <Skeleton width={40} height={30} />
            <Skeleton width={80} height={30} />
        </div>
    </div>
);


export const TableRowSkeleton = () => (
    <tr className="border">
        <td className="border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
            <Skeleton width={120} />
        </td>
        <td className="border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
            <Skeleton width={100} />
        </td>
    </tr>
);



export const ClientHeaderSkeleton = () => (
    <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between items-start xl:items-center gap-[15px] lg:gap-[0px]">
        <div className="w-full xl:w-1/2">
            <Skeleton height={40} className="mb-2" />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
        <div className="w-[120px]">
            <Skeleton height={40} />
        </div>
    </div>
);

export const ClientTableRowSkeleton = () => (
    <tr className="border-b">
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={20} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
        <td className="border-[#dbdbdb] p-3 border-r">
            <Skeleton width={100} height={20} />
        </td>
    </tr>
);
